import { decodeHtmlEntities } from '@msc-b2c/shared-utils';

export const ADDITIONAL_NOTES_TOOLTIP_CONTENT_REGEX = /<p class=(["'“”])ptec\1>(.*?)<\/p>/; // Regex to match <p class="ptec">...</p> or <p class='ptec'>...</p>

export function extractLongDescription(longDescription?: string, isOBS?: boolean): string {
  if (!longDescription) return '';

  const decodedHtml = decodeHtmlEntities(longDescription);
  const decodedHtmlNoPtec = decodedHtml.replace(ADDITIONAL_NOTES_TOOLTIP_CONTENT_REGEX, ''); // Remove <p class="ptec"> tags

  if (isOBS) {
    const decodedHtmlWrapped = wrapOrphanedContent(decodedHtmlNoPtec);
    return decodedHtmlWrapped;
  }

  return decodedHtmlNoPtec;
}

export function extractTooltipContent(longDescription?: string): string | undefined {
  if (!longDescription) return undefined;

  const decodedHtml = decodeHtmlEntities(longDescription);

  const match = decodedHtml.match(ADDITIONAL_NOTES_TOOLTIP_CONTENT_REGEX);

  return match?.[2] ? match[2] : undefined; // Return the content inside the <p class="ptec"> tags
}

// util function to wrap in p tag "orphan" texts
// so we can remove br tags and handle layout
// with margins
function wrapOrphanedContent(htmlString: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
  const container = doc.querySelector('div');

  if (!container) return htmlString;

  container.querySelectorAll('br').forEach((br) => br.remove());

  container.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
      const p = doc.createElement('p');
      p.textContent = node.textContent;
      node.replaceWith(p);
    }
  });

  return container.innerHTML;
}
